import React, {useEffect} from "react";
import * as StorageService from "../services/StorageService.js";
import {LOCALSTORAGE_ITEMS, ORDER_PLACE} from "../util/Constants";
import {PATH} from "../routes/routes";
import * as AccountService from "../services/AccountService";
import {clearStorageItems, handleAppVersionUpdate} from "../util/common";
import {useLocation, useNavigate} from "react-router";
import {useParams} from "react-router-dom";

function BarPickupScan(props) {
    const navigateTo = useNavigate();
    const {shopName} = useParams();

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const refUrl = query.get('refUrl');
    const returningUrl = query.get('returningUrl');

    useEffect(() => {
        handleAppVersionUpdate();

        clearStorageItems();

        StorageService.setItem(LOCALSTORAGE_ITEMS.SHOP_NAME, shopName);
        StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, ORDER_PLACE.BAR);

        AccountService.configApp().then(r=> {

            const url = refUrl
                ? `${PATH.MAIN}?refUrl=${encodeURIComponent(refUrl)}${returningUrl ? `&returningUrl=${encodeURIComponent(returningUrl)}` : ''}&isBarPickup=true`
                : returningUrl
                    ? `${PATH.MAIN}?returningUrl=${encodeURIComponent(returningUrl)}&isBarPickup=true`
                    : `${PATH.MAIN}?isBarPickup=true`;

            navigateTo(url);
        });

    }, []);

    return (
        <div className="redirect-msg">
            Redirecting...
        </div>

    );
}

export default BarPickupScan;
